<!-- template for the modal component -->
<template type="x/template">
    <transition name="modal" id="change-stock-dialog">
        <div class="modal-mask" v-show="show">
            <div class="modal-container" @click.stop>
                <div class="modal-header">
                    <h3>{{ modalData.id ? 'Edit voting poll' : 'New voting poll' }}</h3>
                </div>
                <div class="modal-body">
                    <div class="form-group row">
                        <div class="col-lg-12 pt-4">
                            <div class="row">
                                <label class="control-label">Name</label>
                                <span v-if="modalData.id" class="text-danger"> (Total votes: {{ totalVotes }})</span>
                                <input type="text" class="form-control" v-model="modalData.name"
                                       :class="{ 'field-error' : this.$v.modalData.name.$error }"/>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 hr"></div>
                            </div>
                            <div class="items-holder custom-scrollbar">
                                <div class="row pt-4" v-for="(item, index) in modalData.items">
                                    <div class="col-lg-10 col-sm-8 col-md-8 col-xs-8">
                                        <label class="control-label">Item {{ (index + 1) }}
                                          <span class="text-danger" v-if="modalData.id"> ({{ item.votes ? item.votes : 0}} votes) </span>
                                        </label>
                                        <input type="text" class="form-control" v-model="item.name" v-on:keydown="enterKey"/>
                                    </div>
                                    <div class="col-lg-2 col-sm-2 col-md-2 col-xs-2 del">
                                        <a v-on:click.prevent="confirmDelete(item)">
                                            <i class="fas fa-trash-alt text-danger" title="Törlés" @click="confirmDelete(item)"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12 p-0 pt-3 pl-lg-3">
                                        <button class="btn btn-sm btn-secondary" @click="newItem">+ Add new item</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div class="modal-footer col-lg-12">
                    <div class="form-group row justify-content-center">
                        <div class="col-lg-6">
                            <button class="modal-default-button btn btn-secondary ml-3" @click="close()">Cancel</button>
                        </div>
                        <div class="col-lg-6">
                            <button class="modal-default-button btn btn-primary ml-3" @click="save()">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
  import required from "vuelidate/src/validators/required";

    export default {
        name: 'widget-dialog',
        props: {
            show: {
                type: Boolean,
            },
            data: {
                type: Object,
            },
            method: {
                type: Function
            }
        },
        data() {
            return {
              modalData: this.data ? this.data : {},
            }
        },
      computed: {
        totalVotes() {
            let total = 0;
            if(this.modalData.items) {
                this.modalData.items.map((item => {
                    total += item.votes ? item.votes : 0;
                }));
            }

            return total;
          }
      },
        methods: {
            close: function () {
                this.$emit('close');
            },
            save: function () {
                this.$v.modalData.$touch();

                if(!this.$v.modalData.$invalid && this.modalData.name) {

                    if(this.modalData.items.length > 0) {
                        this.$emit('onProcessed', this.modalData);
                        this.close();
                    } else {
                        this.$store.commit('setErrorMessage', 'You must add at least one item!');
                    }

                } else {
                    this.$emit('onProcessError', this.modalData);
                    this.$store.commit('setErrorMessage', 'Fill out the fields please!');
                }
            },
            confirmDelete(item) {
                this.modalData.items.splice(this.modalData.items.indexOf(item), 1);
            },
            newItem() {

                if(this.modalData.items) {

                    if(!this.modalData.items.find(i => i.name == '')) {
                        this.modalData.items.push({
                            name: '',
                        });

                        $(".items-holder").animate({scrollTop: $('.items-holder').prop("scrollHeight")}, 1000);
                    }
                }
            },
            enterKey(event) {
                if(event && event.keyCode == 13) {
                    this.newItem();
                }
            },
        },
        mounted: function () {
            document.addEventListener("keydown", (e) => {
                if (this.show && e.keyCode == 27) {
                    this.close();
                }
            });
        },
        watch: {
            data: function(newVal) {
                this.modalData = newVal;

                if(this.modalData.method && this.modalData.id) {
                    this.modalData.method(this.modalData.id);
                }
            }
        },
        validations() {
            return {
                modalData: {
                    name: required,
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    * {
        box-sizing: border-box;
    }

    .modal-mask {
        overflow: scroll;
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }

    .modal-container {
        width: 450px;
        margin: 40px auto 0;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0px 0;
    }

    .text-right {
        text-align: right;
    }

    .form-label {
        display: block;
        margin-bottom: 1em;
    }

    .form-label > .form-control {
        margin-top: 0.5em;
    }

    .form-control {
        display: block;
        width: 100%;
        padding: 0.5em 1em;
        line-height: 1.5;
        border: 1px solid #ddd;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .hr {
        border-bottom: 1px #ededed solid;
    }

    .del {
        padding-top: 27px;
        font-size: 20px;
        cursor: pointer;
    }

    .items-holder {
        height: 250px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
